const items = [
  { id: 1, description: 'ICOP (In Community of Property)' },
  { id: 2, description: 'OCOP (Out of Community of Property)' },
  { id: 3, description: 'Other' },
  { id: 4, description: 'Traditional Wedding' },
  { id: 5, description: 'Single' },
  { id: 6, description: 'Divorced' },
  { id: 7, description: 'Widow' },
  { id: 8, description: 'Committed Relationship' },
  { id: 9, description: 'Partner' },
];
export default items;
